<template>
    <div class="course">
        <Top :title="title"></Top>
        <iframe :src="pageurl" width="100%" :height="height" scrolling="yes" frameborder="0"></iframe>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import Top from './module/top_back'


export default{
    name: 'Dishi',
    data(){
        return{
            title: this.$route.params.name,
            city: this.$route.params.city,
            pageurl: '',
            height: window.screen.height.toString()-100
        }
    },
    created(){

    },
    mounted(){
        this.pageurl = 'http://byte.gxnews.com.cn/dishi/'+this.$route.params.city+'/';
    },
    methods:{
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fdishi/${encodeURI(this.title)}/${this.city}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        Top
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 1rem;
        iframe{
            margin-top: 0px;
        }
    }             
</style>   